import EmailFieldBase from '../base/EmailField';
import createField from './createField';

const EmailField = createField(EmailFieldBase);

export default EmailField;
